import React from 'react'
import dollarImg from "../assets/images/dollars.png"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { toggleNotificationPreferencesModal, togglePaymentsOffcanvas } from 'slices/ui/reducer';
import AgencyDropdownFullWidth from 'Components/Common/AgencyDropdownFullWidth';
import HeaderProfileDropdown from 'Components/Common/HeaderProfileDropdown';
import HeaderNotificationDropdown from 'Components/Common/HeaderNotificationDropdown';
import AccessControl from 'wrappers/AccessControl';
import { PRIVILEGE } from 'constants/privilege';
import { formatNumber } from 'utils/helpers';
import Avatar from 'react-avatar';
import NotificationPreferencesModal from './NotificationPreferencesModal';
import { createSelector } from 'reselect';
import { changeSidebarVisibility } from 'slices/thunks';

const Header: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const notificationPreferencesModalVisibility = useSelector((state: RootState) => state.ui.notificationPreferences);
    const campaignData = useSelector((state: RootState) => state.ui.header?.campaignData);
    const competitionGroup = useSelector((state: RootState) => state.ui.header?.competitionGroup);
    const detailPage = useSelector((state: RootState) => state.ui.header?.detailPage)
    const configurations = useSelector((state: RootState) => state.auth.configurations);

    const campaignsLocation = useSelector((state: RootState) => state.ui.campaignsLocation);
    const lastActiveCampaignTab = useSelector((state: RootState) => state.ui.lastActiveCampaignTab);

    const getBalanceColor = (remaining = campaignData?.campaign?.remaining_budget ?? 0) => {
        if (Number(remaining) < 0) return 'text-danger';
        return 'text-success'
    };

    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
    );
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767)
            humberIcon.classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            <div className='new-header d-flex justify-content-between align-items-center'>
                <div className="header-left d-flex justify-content-start align-items-center gap-3">
                    <button
                        onClick={toogleMenuBtn}
                        type="button"
                        className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger d-md-none"
                        id="topnav-hamburger-icon">
                        <span className="hamburger-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </button>
                    {
                        campaignData ? (
                            <React.Fragment>
                                <Link to={campaignsLocation} className="nav-btn cursor-pointer"> <i className='mdi mdi-arrow-left' /> </Link>
                                <div className="campaign-desc d-flex justify-content-start align-items-center gap-3 d-none d-md-flex">
                                    {
                                        campaignData?.brand?.img_url ?
                                            <div className="header-brand-logo bg-image bgc-white" style={{ backgroundImage: `url(${campaignData?.brand?.img_url})` }}></div>
                                            : <Avatar name={campaignData?.campaign?.name} size='40' maxInitials={1} round={'4px'} />
                                    }
                                    <div className="d-flex flex-column justify-content-between">
                                        <span className="campaign-name">{campaignData?.campaign?.name}</span>
                                        {
                                            campaignData?.campaign?.mode !== 'offline' &&
                                            <div className="campaign-actions d-flex gap-2">
                                                {
                                                    detailPage ? (
                                                        <Link to={`/campaign/${campaignData?.campaign?.uuid}/${lastActiveCampaignTab}`} className=" text-primary d-flex align-items-center gap-1">
                                                            Hide Details <i className='fs-15px ms-1 bg-primary-light bx bx-chevron-up'></i>
                                                        </Link>
                                                    ) : (
                                                        <Link to={`/campaign/${campaignData?.campaign?.uuid}`} className=" text-primary d-flex align-items-center gap-1">
                                                            Show Details <i className='fs-15px ms-1 bg-primary-light bx bx-chevron-down'></i>
                                                        </Link>
                                                    )
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </React.Fragment>
                        ) : competitionGroup ? (
                            <React.Fragment>
                                <span onClick={() => navigate('/competitor')} className="nav-btn cursor-pointer"> <i className='mdi mdi-arrow-left' /> </span>
                                <div className="campaign-desc d-flex justify-content-start align-items-center gap-3 d-none d-md-flex">
                                    <div className="d-flex flex-column justify-content-between">
                                        <span className="campaign-name">{competitionGroup?.name}</span>
                                    </div>
                                </div>
                            </React.Fragment>
                        ) : null
                    }
                </div>
                <div className="header-right d-flex justify-content-end align-items-center">
                    {
                        campaignData ? (
                            <React.Fragment>
                                {
                                    campaignData?.campaign?.remaining_budget != null && campaignData?.campaign?.mode !== 'offline' && false &&
                                    <div className="campaign-budget d-flex align-items-center border-right-1 px-4 me-4 d-none d-md-flex">
                                        <img src={dollarImg} alt="campaign-budget" className="budget-img" />
                                        {
                                            formatNumber(Number(campaignData?.campaign?.total_budget)) === formatNumber(Number(campaignData?.campaign?.remaining_budget)) ?
                                                (
                                                    <div className="budget-text d-flex flex-column justify-content-between">
                                                        <div className="d-flex gap-1">
                                                            <span className={`remaining-budget-number ${getBalanceColor()}`}>
                                                                {formatNumber(Number(campaignData?.campaign?.remaining_budget))}
                                                            </span>
                                                        </div>
                                                        <span className="budget-title text-muted">
                                                            Total Budget
                                                        </span>
                                                    </div>
                                                ) :
                                                (
                                                    <div className="budget-text d-flex flex-column justify-content-between">
                                                        <div className="d-flex gap-1">
                                                            <span className={`remaining-budget-number ${getBalanceColor()}`}>
                                                                {formatNumber(Number(campaignData?.campaign?.remaining_budget))}
                                                            </span>
                                                            <span className='budget-number'> / {formatNumber(Number(campaignData?.campaign?.total_budget))}</span>
                                                        </div>
                                                        <span className="budget-title text-muted">
                                                            Budget Remaining
                                                        </span>
                                                    </div>
                                                )
                                        }

                                    </div>
                                }

                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.PAYMENT.INDEX} ifCondition={['approved', 'completed'].includes(campaignData?.campaign?.status) && campaignData?.campaign?.mode !== 'offline' && configurations?.agency_show_campaign_payments === 'y'}>
                                    <div className="d-flex align-items-center pe-2 me-2 pe-md-4 me-md-4 border-right-1 d-none d-md-flex">
                                        <button className='payments-btn' onClick={() => dispatch(togglePaymentsOffcanvas(true))}>Payment Details <i className='bx bx-right-arrow-alt'></i></button>
                                    </div>
                                </AccessControl>
                            </React.Fragment>)
                            : (
                                <div className="border-right-1 pe-2 me-2 pe-md-4 me-md-4">
                                    <AgencyDropdownFullWidth />
                                </div>
                            )
                    }
                    <div className='d-flex align-items-center gap-2 gap-md-3'>
                        <HeaderNotificationDropdown />
                        <HeaderProfileDropdown />
                    </div>
                </div>
            </div>
            <NotificationPreferencesModal
                isOpen={notificationPreferencesModalVisibility}
                onClose={() => dispatch(toggleNotificationPreferencesModal(false))}
            />
        </React.Fragment>

    )
}

export default Header